import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-pres-movimientos-det',
  templateUrl: './pres-movimientos-det.component.html',
  styleUrls: ['./pres-movimientos-det.component.css'],
    providers: [
      {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
      {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
      {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
    ]
})
export class PresMovimientosDetComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=3200;
  resultado:any=[];
  alertaFecha:string="";
  lblFecha:string="";
  alertaImporte:string="";
  lblImporte:string="";
  importe:number = null;
  fec:any = moment();
  ref:string="";
  concep:string="";
  ultMov:any=[];
  lblUltMov:string = "";
  esEgreso:boolean = false;

  thisForm = new FormGroup({
    importe: new FormControl(this.importe, [Validators.required]),
    fec: new FormControl(this.fec, [Validators.required]),
    concep: new FormControl(this.concep, []),
    ref: new FormControl(this.ref, []),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<PresMovimientosDetComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log(this.data);
    var idConSub = 0;
    var idDet = null;
    if(this.data.nivel == 1)
      idConSub = this.data.item.idN1;
    if(this.data.nivel == 2)
      idConSub = this.data.item.idN2;
    if(this.data.nivel == 3){
      idConSub = this.data.item.idN2;
      idDet = this.data.item.idN3;
    }
    if(this.data){
      if(this.data.item.tipo == 'EGRESO' || this.data.item.padre == 'EGRESO')
        this.esEgreso = true;
      else
        this.esEgreso = false;
      this.dataService.getPres_UltMov(1, idConSub, idDet).subscribe(
                                      rows => {   
                                              this.ultMov = <any>rows
                                              },          
                                      error => this.errMsg = <any>error,
                                      () => this.fnUltimoMovCargado());
                                    }
  }

  fnUltimoMovCargado(){
    console.log(this.ultMov);
    if(this.ultMov){
      if(this.ultMov.length == 0){
        this.lblUltMov = "Sin movimientos. "
      }
      else{
        this.lblUltMov = "Ult. Mov: $ " + this.dataService.fnFormatMoney(this.ultMov[0].monto, 2) + " (" + this.ultMov[0].fec + ")";
      }
    }
    else
      this.lblUltMov = "Sin movimientos. "
  }
  
  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
    this.alertaImporte = "";
    var auxImporte = 0;
    var puntoDec1 = -1;
    var puntoDec2 = -1;
    try{
      puntoDec1 = this.thisForm.controls["importe"].value.indexOf(".");
      puntoDec2 = this.thisForm.controls["importe"].value.lastIndexOf(".");
      if(puntoDec1 != puntoDec2){
        console.log(puntoDec1);
        console.log(puntoDec2);
      }
      if(puntoDec2 > 0 && puntoDec1 != puntoDec2){
        this.alertaImporte = "Punto decimal";
        this.lblImporte = "El monto solo utilizará el primer punto decimal !"
      }
      auxImporte = parseFloat(this.thisForm.controls["importe"].value);
      console.log(auxImporte);
      if(auxImporte == 0){
        this.alertaImporte = "Monto == 0";
        this.lblImporte = "El monto del importe debe ser diferente a 0 (cero) !"
      }
      if(auxImporte < 0){
        this.alertaImporte = "Monto negativo";
        this.lblImporte = "El monto del importe debe ser positivo (salvo casos especiales) !"
      }      
    }
    catch{
      console.log("Importe no válido")
    }
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  fnCambiaFecha(tipo, obj){
    this.alertaFecha = "";
    if (tipo=="MOV"){
      this.fec = moment(obj.value.format("YYYY/MM/DD"));
      this.thisForm.controls["fec"].setValue(this.fec);
      var hoy = moment()
      if(this.fec > hoy){
        this.alertaFecha = "Fecha futura";
        this.lblFecha = "ATENCION: El movimiento tiene fecha posterior al día de hoy !";
        //alert("Fecha posterior a hoy")
      }
      if(this.fec < hoy.add(-1, "month")){
        this.alertaFecha = "Fecha con atraso";
        this.lblFecha = "ATENCION: El movimiento tiene fecha con mas de 1 mes de atraso !";
        //alert("Fecha de movimiento con mas de un mes de atraso")
      }
    }
  }

  fnGuardar(){
    this.loading = true;
    //--> Validar movimiento: Importe > 0, (mismo monto, misma fecha); advertencia: fecha < hoy > 30 dias, 
    if(this.thisForm.valid){
      var auxMonto = parseFloat(this.thisForm.controls["importe"].value);
      if(auxMonto == 0){
        this.fnMuestraMensaje("ERR", "El 'Importe' no puede ser 0 (cero).", true, false);
        return;
      }
      if(auxMonto < 0){

      }
      /*
      var auxFecha = moment(this.thisForm.controls["fec"].value);
      var hoy = moment()
      if(auxFecha > hoy){
        alert("Fecha posterior a hoy")
      }
      if(auxFecha < hoy.add(-1, "month")){
        alert("Fecha de movimiento con mas de un mes de atraso")
      }
      */
      var idConSub = 0;
      var idDet = null;
      if(this.data.nivel == 1)
        idConSub = this.data.item.idN1;
      if(this.data.nivel == 2)
        idConSub = this.data.item.idN2;
      if(this.data.nivel == 3){
        idConSub = this.data.item.idN2;
        idDet = this.data.item.idN3;
      }
      this.dataService.insPres_Mov(idConSub, idDet, auxMonto, moment(this.thisForm.controls["fec"].value).format("YYYY/MM/DD"), this.thisForm.controls["ref"].value, this.esEgreso ? this.thisForm.controls["concep"].value : null).subscribe(
                      rows => {   
                              this.resultado = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnMovimientoGuardado());    
      
    }
     else{
      console.log(this.thisForm.controls["importe"].errors);
      if(this.thisForm.controls["importe"].errors.required)
        this.fnMuestraMensaje("ERR", "Capture el 'Importe'.", true, false)
    }
  }

  fnMovimientoGuardado(){
    console.log(this.resultado);
    if(this.resultado == 1){
      this.fnMuestraMensaje("OK", "Movimiento ingresado correctamente.", true, true)
    }
    else{
      this.fnMuestraMensaje("ERR", "Error al ingresar movimiento.", true, false)
    }
    //this.loading = false;
  }

}
